import { render, staticRenderFns } from "./SonMenu.vue?vue&type=template&id=6249f03e&scoped=true"
import script from "./SonMenu.vue?vue&type=script&lang=js"
export * from "./SonMenu.vue?vue&type=script&lang=js"
import style0 from "./SonMenu.vue?vue&type=style&index=0&id=6249f03e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6249f03e",
  null
  
)

export default component.exports